/** @format */

import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconMoneyCashFill,
  homefieldIconMoneyPaymentsAffirmFill,
  homefieldIconMoneyPaymentsAfterpayFill,
  homefieldIconMoneyPaymentsAmex,
  homefieldIconMoneyPaymentsDiscover,
  homefieldIconMoneyPaymentsMastercard,
  homefieldIconMoneyPaymentsPaypalFill,
  homefieldIconMoneyPaymentsPlccFill,
  homefieldIconMoneyPaymentsScorecardFill,
  homefieldIconMoneyPaymentsVisa,
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PaymentSummaryComponent } from './payment-summary.component';
import { PhoneNumberPipe } from '@shared/utils/pipes';

@NgModule({
  declarations: [PaymentSummaryComponent],
  imports: [CommonModule, HomefieldIconLibraryModule, PhoneNumberPipe],
  exports: [PaymentSummaryComponent],
})
export class PaymentSummaryModule {
  constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
    homefieldIconsLibraryService.registerIcons([
      homefieldIconMoneyPaymentsAffirmFill,
      homefieldIconMoneyPaymentsAfterpayFill,
      homefieldIconMoneyPaymentsAmex,
      homefieldIconMoneyPaymentsDiscover,
      homefieldIconMoneyPaymentsVisa,
      homefieldIconMoneyPaymentsMastercard,
      homefieldIconMoneyPaymentsPlccFill,
      homefieldIconMoneyPaymentsPaypalFill,
      homefieldIconMoneyPaymentsScorecardFill,
      homefieldIconMoneyCashFill,
    ]);
  }
}
